import {useNavigate } from "react-router-dom";
import { Box, Progressbar, Button, Heading, Link } from "@ogt/ui";

export default function Intro() {
  const navigate = useNavigate();
  const progress = 0;
  return (
    <div>
      <div className="flex justify-end items-center">
        <div className="w-full max-w-xs mb-4">
          <Progressbar percentage={progress} />
        </div>
      </div>
      <Box>
        <Heading>Innan ni börjar er anmälan</Heading>
        <p>
          Tack för att ni väljer att resa hållbart. Innan ni påbörjar er anmälan
          finns det några viktiga saker att känna till om gruppresor;
        </p>

        <ul>
          <li>Resan behöver anmälas minst fem dagar i förväg.</li>
          <li>Vi kan inte garantera en plats på turen trots föranmälan.</li>
          <li>
            Ni behöver själva hålla koll på om avgångstiden för turen ändras.
            Det gör ni genom att söka resan i appen eller på webben.
          </li>
          <li>Eventuell barnvagn och/eller rullstol tas med i mån av plats.</li>
          <li>
            Är ni en skolklass som reser rekommenderar vi en Kulturbiljett. Den
            köper ni i vår företagsportal. Vi hjälper er dit när ni skickat in
            er anmälan.
          </li>
        </ul>
        <p>
          Om ni stöter på frågor längs vägen är ni välkomna att höra av er till
          vår kundservice på <Link  className="inline!" underline="always" href="tel:0771-21 10 10">0771-21 10 10</Link>.
        </p>
      </Box>

      <div className="flex justify-center">
        <div className="w-full text-right">
          <Button
            onClick={() => navigate("/vart-vill-ni-resa")}
            className="w-full sm:w-auto"
            type="submit"
          >
            Anmäl gruppresa
          </Button>
        </div>
      </div>
    </div>
  );
}
